// extracted by css-extract-rspack-plugin
module.exports =  {"itemCell":"DocumentRequestDialog__itemCell___i7Zw5","itemTitle":"DocumentRequestDialog__itemTitle___cJLXR","listHeaderTitle":"DocumentRequestDialog__listHeaderTitle___U7VQw"};